import { render, staticRenderFns } from "./GmbAttributeItemBool.vue?vue&type=template&id=5b4a7ed2&"
import script from "./GmbAttributeItemBool.vue?vue&type=script&lang=js&"
export * from "./GmbAttributeItemBool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports